import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

import { MarketingContact } from '../_models/marketing-contact';

@Injectable()
export class MarketingService {
    private readonly apiController: string;

    constructor(private readonly httpClient: HttpClient) {
        this.apiController = `${environment.webApiUrl}/api/v${environment.webApiVersion}/marketing`;
    }

    signUpForUpdates(marketingContact: MarketingContact): Observable<any> {
        const httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.httpClient.post<any>(`${this.apiController}/addMarketingContact`, marketingContact, { headers: httpHeaders});
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/marketing.service.ts